module.exports = __webpack_public_path__ + "img/sicily.e1b908df.svg";